import { useState } from "react";
import { useTranslation } from "react-i18next";
import { IconEditarDesk } from "@/assets/images/Icons";
import { ModalCriacaoCampanha } from "@/components/ModalCriacaoCampanha/ModalCriacaoCampanha";
import { useLayout } from "@/contexts/UseLayout";
import TemPermissao from "@/components/utils/NiveisDeAcesso";

export function FormCampanhas({ campanha }: any) {
  const { t } = useTranslation();
  const { userLogged } = useLayout();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <>
      {campanha
        ? TemPermissao(userLogged, "campanhas", "editar") && (
            <button
              className="p-2 bg-azul-400/20 hover:bg-azul-400 text-azul-400 hover:text-white duration-300 disabled:cursor-not-allowed"
              onClick={() => setIsOpen(true)}
              title={t("userGoOn:overview.campaigns.buttons.edit")}
            >
              <IconEditarDesk />
            </button>
          )
        : TemPermissao(userLogged, "campanhas", "criar") && (
            <button
              onClick={() => setIsOpen(true)}
              className="bg-azul-400 text-sm text-white px-8 py-2 rounded-lg hover:bg-azul-400/90 duration-300"
            >
              {t("userGoOn:overview.campaigns.newCampaign")}
            </button>
          )}
      {isOpen && (
        <ModalCriacaoCampanha
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          campanha={campanha}
        />
      )}
    </>
  );
}
